import type { RefObject } from 'react';
import { slideUpFadeIn } from '../../../../util/animation/slide/slide';

interface NavigationListRefs {
  elementRef: RefObject<HTMLUListElement | null>;
  listItemsRef: RefObject<Array<HTMLElement> | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { listItemsRef }: NavigationListRefs,
): void {
  if (listItemsRef?.current && listItemsRef?.current?.length > 0) {
    timeline.add(slideUpFadeIn(listItemsRef.current as Array<HTMLElement>, { stagger: 0.05 }));
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: NavigationListRefs,
): void {
  timeline.to(elementRef.current, { opacity: 0, duration: 0.3 });
}
